if (!customElements.get('video-testimonials-component')) {
  class VideoTestimonials extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);

      // Initialize video handling
      this.initVideoHandling();
    }
    initVideoHandling() {
      this.playButtons = this.querySelectorAll('.video-testimonials__play-button');
      this.videoContainers = this.querySelectorAll('.video-testimonials__video--placeholder');
      
      // Play button click handlers
      this.playButtons.forEach((button, index) => {
        button.addEventListener('click', (e) => {
          this.handlePlayButtonClick(e);
        });
      });
      
      // Scroll past section to reset all videos
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) {
            this.resetAllVideos();
          }
        });
      }, {
        threshold: 0.1
      });
      
      this.observer.observe(this.section);
    }

    handlePlayButtonClick(event) {
      const videoContainer = event.target.closest('.video-testimonials__item');
      const playButton = event.target.closest('.video-testimonials__play-button');
      const videoUrl = playButton.getAttribute('data-video-url');
      const videoType = playButton.getAttribute('data-video-type') || 'external';
      const videoPlaceholder = videoContainer.querySelector('.video-testimonials__video--placeholder');
      const videoContent = videoContainer.querySelector('.video-testimonials__video-content');
      
      if (!videoContent) return;

      // --- SHOPIFY HOSTED VIDEO (native <video> element) ---
      if (videoType === 'shopify') {
        const nativeVideo = videoContent.querySelector('.video-testimonials__native-video');
        if (!nativeVideo) return;

        // Hide play button
        playButton.style.display = 'none';

        // Hide thumbnail / placeholder
        const thumbnailImg = videoContainer.querySelector('.video-testimonials__thumbnail-img');
        const placeholderImg = videoContainer.querySelector('.video-testimonials__placeholder-img');
        if (thumbnailImg) thumbnailImg.style.display = 'none';
        if (placeholderImg) placeholderImg.style.display = 'none';

        // Show and play the native video
        nativeVideo.style.display = 'block';
        nativeVideo.play().catch(() => {
          // Autoplay blocked — video is visible with controls so user can tap play
        });

        return;
      }

      // --- EXTERNAL VIDEO (YouTube / Vimeo via iframe) ---
      if (videoUrl && videoPlaceholder && videoContent) {
        // Hide only the current video's play button
        playButton.style.display = 'none';
        
        // Show loading overlay
        const loadingOverlay = videoContent.querySelector('.video-testimonials__loading-overlay');
        if (loadingOverlay) {
          loadingOverlay.style.display = 'flex';
        }
        
        // Remove any existing iframe from this video container only
        const existingIframe = videoContent.querySelector('iframe');
        if (existingIframe) {
          existingIframe.remove();
          // Show the thumbnail again when removing iframe
          const thumbnailImg = videoContainer.querySelector('.video-testimonials__thumbnail-img');
          const placeholderImg = videoContainer.querySelector('.video-testimonials__placeholder-img');
          if (thumbnailImg) {
            thumbnailImg.style.display = 'block';
          }
          if (placeholderImg) {
            placeholderImg.style.display = 'flex';
          }
        }
        
        // Create iframe for Vimeo video
        const iframe = document.createElement('iframe');
        
        // Ensure the video URL is in the correct Vimeo embed format
        let embedUrl = videoUrl;
        
        if (videoUrl.includes('vimeo.com/')) {
          // Handle different Vimeo URL formats
          let videoId;
          if (videoUrl.includes('player.vimeo.com/video/')) {
            // Already in embed format, just add autoplay
            videoId = videoUrl.split('player.vimeo.com/video/')[1].split('?')[0];
            embedUrl = `https://player.vimeo.com/video/${videoId}?autoplay=1&loop=0&muted=0`;
          } else if (videoUrl.includes('vimeo.com/')) {
            // Convert vimeo.com/123456 to player.vimeo.com/video/123456
            videoId = videoUrl.split('vimeo.com/')[1].split('?')[0];
            embedUrl = `https://player.vimeo.com/video/${videoId}?autoplay=1&loop=0&muted=0`;
          }
        } else if (videoUrl.includes('vimeo.com')) {
          // Handle other vimeo.com formats
          const videoId = videoUrl.match(/vimeo\.com\/(\d+)/);
          if (videoId) {
            embedUrl = `https://player.vimeo.com/video/${videoId[1]}?autoplay=1&loop=0&muted=0`;
          }
        }

        // YOUTUBE
        if (videoUrl.includes('youtube.com') || videoUrl.includes('youtu.be')) {
          let videoId;

          if (videoUrl.includes('youtube.com/watch')) {
            const urlParams = new URL(videoUrl).searchParams;
            videoId = urlParams.get('v');

          } else if (videoUrl.includes('youtu.be/')) {
            videoId = videoUrl.split('youtu.be/')[1].split('?')[0];

          } else if (videoUrl.includes('youtube.com/embed/')) {
            videoId = videoUrl.split('youtube.com/embed/')[1].split('?')[0];

          } else if (videoUrl.includes('youtube.com/shorts/')) {
            // Shorts support
            videoId = videoUrl.split('youtube.com/shorts/')[1].split('?')[0];
          }

          if (videoId) {
            embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&playsinline=1`;
          }
        }
        
        iframe.src = embedUrl;
        iframe.frameBorder = '0';
        iframe.allow = 'autoplay; fullscreen; picture-in-picture; encrypted-media';
        iframe.allowFullscreen = true;
        iframe.style.width = '100%';
        iframe.style.height = '100%';
        iframe.style.position = 'absolute';
        iframe.style.top = '0';
        iframe.style.left = '0';
        iframe.style.borderRadius = '1.6rem';
        
        // Add iframe to video content (don't replace everything yet)
        videoContent.appendChild(iframe);
        
        // Add iframe load event listener
        iframe.addEventListener('load', () => {
          // Hide loading overlay
          if (loadingOverlay) {
            loadingOverlay.style.display = 'none';
          }
          // Hide the thumbnail/placeholder image only when iframe loads
          const thumbnailImg = videoContainer.querySelector('.video-testimonials__thumbnail-img');
          const placeholderImg = videoContainer.querySelector('.video-testimonials__placeholder-img');
          
          if (thumbnailImg) {
            thumbnailImg.style.display = 'none';
          }
          if (placeholderImg) {
            placeholderImg.style.display = 'none';
          }
          // The iframe is already visible, no need to hide the placeholder container
          // The thumbnail is already hidden above, so the iframe will be visible
        });
        
        iframe.addEventListener('error', (e) => {
          // Hide loading overlay
          if (loadingOverlay) {
            loadingOverlay.style.display = 'none';
          }
          // Show thumbnail/placeholder again on error
          const thumbnailImg = videoContainer.querySelector('.video-testimonials__thumbnail-img');
          const placeholderImg = videoContainer.querySelector('.video-testimonials__placeholder-img');
          
          if (thumbnailImg) {
            thumbnailImg.style.display = 'block';
          }
          if (placeholderImg) {
            placeholderImg.style.display = 'flex';
          }
          // The placeholder container stays visible, we just show the thumbnail again
          // Show play button again
          playButton.style.display = 'flex';
        });
      }
    }

    hideAllPlayButtons() {
      this.playButtons.forEach(button => {
        button.style.display = 'none';
      });
    }
    
    showAllPlayButtons() {
      this.playButtons.forEach(button => {
        button.style.display = 'flex';
      });
    }

    removeAllIframes() {
      const iframes = this.querySelectorAll('iframe');
      iframes.forEach(iframe => {
        iframe.remove();
      });
    }

    resetAllVideos() {
      this.removeAllIframes();
      this.showAllPlayButtons();
      
      // Pause and hide all native video elements (Shopify hosted)
      const nativeVideos = this.querySelectorAll('.video-testimonials__native-video');
      nativeVideos.forEach(video => {
        video.pause();
        video.currentTime = 0;
        video.style.display = 'none';
      });

      // Hide all loading overlays
      const loadingOverlays = this.querySelectorAll('.video-testimonials__loading-overlay');
      loadingOverlays.forEach(overlay => {
        overlay.style.display = 'none';
      });
      
      // Show all thumbnail/placeholder images again
      const thumbnailImgs = this.querySelectorAll('.video-testimonials__thumbnail-img');
      const placeholderImgs = this.querySelectorAll('.video-testimonials__placeholder-img');
      
      thumbnailImgs.forEach(img => {
        img.style.display = 'block';
      });
      placeholderImgs.forEach(img => {
        img.style.display = 'flex';
      });
    }


    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }
  }
  customElements.define('video-testimonials-component', VideoTestimonials);
}


if (!customElements.get('testimonial-layered')) {
  class TestimonialLayered extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.hoverToOpen = this.trigger === 'hover' && window.matchMedia("(hover: hover)").matches ? true : false;

      if (this.hoverToOpen) {
        this.addEventListener('mouseenter', this.handleMouseOver.bind(this));
        this.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
      }

      this._open = this.hasAttribute('open');
      this.header = this.querySelector('.testimonial__header');
      this.text = this.querySelector('.testimonial__text');
      this.content = this.querySelector('.testimonial__content');
      this.summary = this.querySelector('.testimonial__summary');
      this.testimonialInner = this.querySelector('.testimonial__inner');
      this.header && this.header.addEventListener('click', this.handleClick.bind(this));
      document.addEventListener('click', this.handleOutsideClick.bind(this));
    }

    disconnectCallback() {
      this.header && this.header.removeEventListener('click', this.handleClick.bind(this));
      document.removeEventListener('click', this.handleOutsideClick.bind(this));
    }

    set open(value) {
      if (value !== this._open) {
        this._open = value;
  
        if (value) {
          this.setAttribute('open', '');
        } else {
          this.removeAttribute('open');
        }
      }
    }
  
    get open() {
      return this._open;
    }

    get trigger() {
      if (this.hasAttribute('data-trigger')) {
        return this.getAttribute('data-trigger');
      } else {
        return 'click';
      }
    }

    handleClick(event) {
      event.preventDefault();
      this.open = !this.open;
      this.toggleColor();
      this.toggleContentOverflow();
    }

    handleOutsideClick(event) {
      const isClickInside = this.testimonialInner.contains(event.target);

      if (!isClickInside) {
        this.open = false;
      }
      this.toggleColor();
      this.toggleContentOverflow();
    }

    handleMouseOver(e) {
      this.open = true;
      this.hoverTimeout = setTimeout(() => {
        if (this.text.getBoundingClientRect().height > this.content.getBoundingClientRect().height) this.content.classList.add('overflow-auto');
      }, 600);

      this.toggleColor();
    }

    handleMouseLeave(e) {
      this.open = false;
      clearTimeout(this.hoverTimeout);
      this.content.classList.remove('overflow-auto');

      this.toggleColor();
    }

    toggleColor() {
      const {colorScheme, contentColorScheme} = this.dataset;
      this.testimonialInner.classList.toggle(contentColorScheme, this.open);
      this.testimonialInner.classList.toggle(colorScheme, !this.open );
    }

    toggleContentOverflow() {
      if (!this.content || !this.text) return;

      const activeTimeOut = setTimeout(() => {
        const isScrollable = this.open ? (this.text.getBoundingClientRect().height > this.content.getBoundingClientRect().height) : false;
        if (isScrollable) this.content.classList.add('overflow-auto');
      }, 600);

      if (!this.open) {
        clearTimeout(activeTimeOut);
        this.content.classList.remove('overflow-auto');
      }
    }
  }
  customElements.define('testimonial-layered', TestimonialLayered);
}
